import { Helmet } from "react-helmet-async";

interface PageMetaProps {
  title: string;
  description: string;
  path: string;
  /** Absolute https URL of the share image. Defaults to the site-wide one. */
  image?: string;
  /** Open Graph type — "website" for landings, "article" for blog posts. */
  type?: "website" | "article";
}

const SITE_URL = "https://tipomatic.app";
const DEFAULT_OG_IMAGE =
  "https://storage.googleapis.com/gpt-engineer-file-uploads/KvaFXCDNwQM6DAddPbab83PyGPr2/social-images/social-1780375525121-og-image.webp";

/**
 * Per-route SEO meta tags. Sets <title>, description, canonical and
 * Open Graph url/title/description/image for the current page, overriding
 * the static defaults in index.html.
 */
export function PageMeta({ title, description, path, image, type = "website" }: PageMetaProps) {
  const url = `${SITE_URL}${path}`;
  const ogImage = image ?? DEFAULT_OG_IMAGE;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content="Tipomatic" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
